<template>
 <div class="bg-[#23242A] text-white app-header p-3 custom">

    <div :class="'px-3 pt-3 pb-20 flex content-main gap-5 ' + (action.component ? ' half-it' : '')">
      
      <div class="custom-full custom-left">
        <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]">

          <template v-if="vg_selectedLocation.id">
            <div class="flex justify-between mb-5">
              <h2 class="text-[24px] font-semibold text-white">Holidays</h2>
              <mdicon @click="addUpdate({ component: 'Add', data: {} })" v-if="!action.component" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
            </div>
            <List :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
          </template>

          <p v-else class="text-center text-theme-red">Please select a location from the top left corner.</p>

        </div>
      </div>
  
      <div :class="'w-full hidden-component custom-right'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

  </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import List from '@/views/Location/Holiday/List.vue';
import Add from '@/views/Location/Holiday/Add.vue';
import Update from '@/views/Location/Holiday/Update.vue';

  export default defineComponent({
  name: "LocationHolidays",
  components: {
    List,
    Add,
    Update,
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

  watch : {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {
    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
    this.emitter.on("reset-location-holidays-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-location-holidays-component', () => {});
    this.emitter.off('refresh-location-holidays-list', () => {});
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>